var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'showDate')?_c('div',[_vm._v(" "+_vm._s(_vm.dateFriendly)+" ")]):_c('ElTooltip',{attrs:{"content":_vm.tooltip}},[_c('span',{staticStyle:{"cursor":"default"}},[_vm._v(_vm._s(_vm.distance))])])}
var staticRenderFns = []

export { render, staticRenderFns }